// extracted by mini-css-extract-plugin
module.exports =  {"details":"ActivationCodeForm-L8IF__details","form":"ActivationCodeForm-adYs__form"};